/*
 *   File : mandate-details.js
 *   Author : https://evoqins.com
 *   Description : Mandate details modal
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React from 'react';


//Assets
import Close from "../../Assets/Images/close-btn-white.svg";

const MandateDetailsModal = (props) => {

    return (
        <div className="modal fade"
            data-bs-backdrop="static"
            id="mandate-details-modal"
            tabIndex="-1"
            aria-labelledby="MandateDetailsModalLabel"
            aria-hidden="true">
            <div className="modal-dialog  modal-dialog-centered" >
                <div className="modal-content e-bg-blur-gradient e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header border-0 justify-content-between align-items-center pt-4 pb-0 px-4 ">
                        <h1 className='e-text-charleston-green e-font-16-res e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px mb-0'>
                            Mandate details
                        </h1>
                        <img src={Close}
                            id='mandate-details-modal-close'
                            draggable={false}
                            className='cursor-pointer width-24px-res'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onCloseModal}
                        />
                    </div>
                    <div className="modal-body text-center p-4">
                        <div className="d-flex justify-content-between mb-3">
                            <p className='e-text-sonic-silver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px mb-0'>
                                Mandate ID
                            </p>
                            <p className='e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px mb-0'>
                                {props.data.id}
                            </p>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                            <p className='e-text-sonic-silver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px mb-0'>
                                Mandate amount
                            </p>
                            <p className='e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px mb-0'>
                                Up to <span className='e-font-weight-700'>₹{props.data.amount && props.data.amount.toLocaleString("en-IN")}</span>
                            </p>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                            <p className='e-text-sonic-silver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px mb-0'>
                                Start date
                            </p>
                            <p className='e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px mb-0'>
                                {props.data.start_date}
                            </p>
                        </div>
                        <div className="d-flex justify-content-between">
                            <p className='e-text-sonic-silver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px mb-0'>
                                End date
                            </p>
                            <p className='e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px mb-0'>
                                {props.data.end_date}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MandateDetailsModal